let integratedApi = '';
let ctmApi = '';
let itmApi = '';
let userSite = '';

if (location.origin.includes('local') || location.origin.includes('stage')) {
  // if (location.origin.includes('stage')) {
  integratedApi = 'https://api-stage-integrated-sugang.carrotapply.com'; //통합수강신청 api 주소
  ctmApi = 'https://applystage.carrotenglish.net';
  itmApi = 'https://stage-itmsugang-api.carrotenglish.net';
  userSite = 'https://stage-integrated-sugang.carrotapply.com';
} else {
  integratedApi = 'https://api-integrated-sugang.carrotapply.com'; //통합수강신청 api 주소
  ctmApi = 'https://apply.carrotenglish.net';
  itmApi = 'https://apply-api.carrotglobal.com';
  userSite = 'https://carrotapply.com';
}

export { integratedApi, ctmApi, itmApi, userSite };
